import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./index.css";
import CustomButton from "../../../common/CustomButton";
import { useSelector, useDispatch } from "react-redux";
import { getApi, updateUserStatus } from "../../../../actions/structure.action";
import { tableStructures } from "../../../../helpers/table-structures";
import Spinner from "../../../common/Spinner";
import CustomTable from "../../common/CustomTable";
import { stringConstants } from "../../../../helpers";
import isEmpty from "../../../../utils/is-Empty";
import Select from "react-select";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import { toast } from "react-toastify";

const UsersList = ({ roleType }) => {
  const dispatch = useDispatch();
  const [statusFilter, setStatusFilter] = useState("all");
  const [filteredData, setFilteredData] = useState([]);
  const [roleTypeFilter, setRoleTypeFilter] = useState("all");
  const [cityFilter, setCityFilter] = useState("");
  const [subscriptionFilter, setSubscriptionFilter] = useState("all");
  const [cities, setCities] = useState([]);
  const [lpTypeFilter, setLpTypeFilter] = useState("");
  const [lpTypeFilterOptions, setLpTypeFilterOptions] = useState([]);
  const [businessNameFilterOptions, setBusinessNameFilterOptions] = useState([]);
  const [businessNameFilter, setBusinessNameFilter] = useState("");
  const [createEmployee, setCreateEmployee] = useState(false);
  const [uploadFormObj, setUploadFormObj] = useState({});

  const { userList, requestCall } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    if (!isEmpty(userList) && userList?.data?.length > 0) {
      // business_info.business_name
      const uniqueNames = [
        ...new Set(userList.data.map((u) => u.business_info?.business_name).filter(Boolean)),
      ].sort((a, b) => a.localeCompare(b));
      setBusinessNameFilterOptions(uniqueNames);

      if (roleType === "seller") {
        const uniqueCities = [
          ...new Set(userList.data.map((u) => u.seller_address?.city).filter(Boolean)),
        ].sort((a, b) => a.localeCompare(b));
        setCities(uniqueCities);
      } else if (roleType === "buyer") {
        const uniqueCities = [
          ...new Set(userList.data.map((u) => u.buyer_address?.city).filter(Boolean)),
        ].sort((a, b) => a.localeCompare(b));
        setCities(uniqueCities);
      } else if (roleType === "logistic_partner") {
        const uniqueCities = [
          ...new Set(userList.data.map((u) => u.business_info?.city).filter(Boolean)),
        ].sort((a, b) => a.localeCompare(b));
        setCities(uniqueCities);

        // Get unique LP types (fallback to "others")
        const uniqueLpTypes = [
          ...new Set(
            userList.data
              .map((u) => u.business_info?.seller_business_name || "others")
              .filter(Boolean),
          ),
        ].sort((a, b) => a.localeCompare(b));

        // Remove "others" if it exists (we will add it manually on top)
        const filteredTypes = uniqueLpTypes.filter((type) => type.toLowerCase() !== "others");

        // Final ordered options
        const finalOptions = [
          "others", // Individual next
          ...filteredTypes,
        ];

        setLpTypeFilterOptions(finalOptions);
      } else if (roleType === "employee") {
        setCreateEmployee(false);
      }

      setUploadFormObj({});
    }
    // else {
    //   if (roleType === "employee") {
    //     setCreateEmployee(true);
    //   }
    // }
  }, [userList, roleType]);

  useEffect(() => {
    setCreateEmployee(false);

    if (roleType === "seller") {
      getApi("getUserListSeller", dispatch);
    } else if (roleType === "buyer") {
      getApi("getUserListBuyer", dispatch);
    } else if (roleType === "employee") {
      getApi("getUserListEmployee", dispatch);
    } else if (roleType === "logistic_partner") {
      getApi("getUserListLogisticPartner", dispatch);
    }
  }, [roleType, dispatch]);

  useEffect(() => {
    if (userList?.data?.length > 0) {
      let mFiltered = userList?.data;

      // Status filter
      if (statusFilter !== "all") {
        mFiltered = mFiltered.filter((user) => user?.status === parseInt(statusFilter));
      } else {
        mFiltered = mFiltered.filter((user) => user?.status !== null);
      }

      // Role Type filter
      if (roleType === "seller") {
        if (roleTypeFilter !== "all") {
          mFiltered = mFiltered.filter(
            (user) => user?.roles_type?.role_type_name === roleTypeFilter,
          );
        } else {
          mFiltered = mFiltered.filter((user) => user?.roles_type?.role_type_name !== null);
        }

        // Subscription filter
        if (subscriptionFilter !== "all") {
          mFiltered = mFiltered.filter(
            (user) => user?.business_info?.app_features === subscriptionFilter,
          );
        } else {
          mFiltered = mFiltered.filter((user) => user?.business_info?.app_features !== null);
        }

        // City Filter
        if (cityFilter !== "") {
          mFiltered = mFiltered.filter((user) => user?.seller_address?.city === cityFilter);
        }
      } else if (roleType === "buyer") {
        if (cityFilter !== "") {
          mFiltered = mFiltered.filter((user) => user?.buyer_address?.city === cityFilter);
        }
      } else if (roleType === "logistic_partner") {
        if (cityFilter !== "") {
          mFiltered = mFiltered.filter((user) => user?.business_info?.city === cityFilter);
        }
        if (!isEmpty(lpTypeFilter)) {
          if (lpTypeFilter === "others") {
            mFiltered = mFiltered.filter(
              (user) => user?.business_info?.logistic_type?.toLowerCase() === "others",
            );
          } else {
            mFiltered = mFiltered.filter(
              (user) => user?.business_info?.seller_business_name === lpTypeFilter,
            );
          }
        }
      }

      // Business Name Filter
      if (businessNameFilter !== "") {
        mFiltered = mFiltered.filter(
          (user) => user?.business_info?.business_name === businessNameFilter,
        );
      }

      setFilteredData(mFiltered);
    }
  }, [
    userList,
    statusFilter,
    roleTypeFilter,
    subscriptionFilter,
    roleType,
    cityFilter,
    lpTypeFilter,
    businessNameFilter,
  ]);

  const onSelectValue = (key, value) => {
    let updatedObj = {};
    updatedObj[key] = value;

    setUploadFormObj((previousValues) => ({
      ...previousValues,
      ...updatedObj,
    }));
  };

  const handleCreateEmployee = async () => {
    console.log("---> UploadFormObj: ", uploadFormObj);
    try {
      if (!isEmpty(uploadFormObj)) {
        const mUrl = uploadFormObj.id
          ? BHAREE_BASE_URL_LOCAL + "/admin/updateEmployee"
          : BHAREE_BASE_URL_LOCAL + "/admin/createEmployee";

        const res = await axios.post(mUrl, uploadFormObj, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Authorization: `Bearer ${localStorage.jwtToken}`,
          },
        });
        console.log("handleCreateEmployee >> response: ", res);
        if (res.status === 200) {
          getApi("getUserListEmployee", dispatch);
          setCreateEmployee(false);
          toast.success(
            uploadFormObj.id
              ? "Employee details updated successfully."
              : "Employee created successfully.",
          );
        } else {
          toast.error("Something went wrong. Please try again. Error: " + res.statusText);
        }
      }
    } catch (error) {
      console.error("Error Occurred: ", error);
      toast.error("Error Occurred: " + error?.response?.data?.message || error.message);
    }
  };

  return (
    <Container fluid className="bhree-admin-user-list p-0">
      {(() => {
        if (createEmployee) {
          return (
            <div className="p-3 create-employee">
              <Row>
                <Col md={6} className="text-start">
                  <h4>Create Employee</h4>
                </Col>
                <Col md={6} className="text-end">
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setCreateEmployee(false)}
                  >
                    <i className="bi bi-x-lg"></i> Close
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col md={6} className="form-col text-start">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Mobile"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>
                    <Form.Control
                      type="tel"
                      required
                      placeholder="Enter mobile number"
                      pattern="[6-9][0-9]{9}" // Indian mobile numbers
                      maxLength={10}
                      value={uploadFormObj?.mobile || ""}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, ""); // allow digits only
                        onSelectValue("mobile", value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className="form-col text-start">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Email"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      required
                      placeholder="Enter email"
                      value={uploadFormObj?.email || ""}
                      onChange={(e) => {
                        onSelectValue("email", e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col md={6} className="form-col text-start">
                  <Form.Group className="mb-3" controlId="formBasicEmail">
                    <Form.Label>
                      {"Full Name"}
                      <span className="redStreSpan">{"*"}</span>
                    </Form.Label>
                    <Form.Control
                      type="email"
                      required
                      placeholder="Enter full name"
                      value={uploadFormObj?.full_name || ""}
                      onChange={(e) => {
                        onSelectValue("full_name", e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Button variant="secondary" onClick={() => setCreateEmployee(false)}>
                    <i className="bi bi-x-lg"></i> Cancel
                  </Button>
                  <Button
                    variant="primary"
                    className="ms-2 btn-save"
                    onClick={handleCreateEmployee}
                  >
                    <i class="bi bi-floppy-fill"></i> Save
                  </Button>
                </Col>
              </Row>
            </div>
          );
        }
        if (userList?.data?.length > 0 && !userList.loading) {
          return (
            <Row className="m-0">
              {/* Custom Top Bar */}
              <Col xs={12} className="px-0" style={{ backgroundColor: "#ffffff" }}>
                <Row className="m-0 p-0 align-items-center">
                  <Col md={4} xs={12} className="mt-3">
                    <div className="table-heading-wrap">
                      <h4>
                        {(() => {
                          if (roleType === "seller") return "Sellers";
                          else if (roleType === "buyer") return "Buyers";
                          else if (roleType === "employee") return "Employees";
                          else if (roleType === "logistic_partner") return "Logistic Partners";
                          else return "Users";
                        })()}
                      </h4>
                    </div>
                  </Col>
                  {/* Dropdown for seller role type */}
                  <Col md={8} xs={12} className="mt-3 text-end admin-filter-col">
                    {roleType === "logistic_partner" && (
                      <Select
                        isSearchable
                        isClearable
                        options={lpTypeFilterOptions.map((lp) => ({
                          value: lp,
                          label: lp === "all" ? "ALL" : lp === "others" ? "Individual" : lp,
                        }))}
                        value={
                          lpTypeFilter
                            ? {
                                value: lpTypeFilter,
                                label:
                                  lpTypeFilter === "all"
                                    ? "ALL"
                                    : lpTypeFilter === "others"
                                      ? "Individual"
                                      : lpTypeFilter,
                              }
                            : null
                        }
                        onChange={(selected) => setLpTypeFilter(selected?.value || "")}
                        placeholder="Filter Seller LPs"
                        classNamePrefix="lp-react-select-filter"
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: "155px",
                            display: "inline-block",
                            fontSize: "0.875rem",
                            textAlign: "left",
                          }),
                          control: (base) => ({
                            ...base,
                            minHeight: "31px",
                            height: "31px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 4px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "31px",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix placeholder alignment
                          }),
                          singleValue: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix selected value alignment
                          }),
                          menu: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix dropdown alignment
                            zIndex: 9999,
                          }),
                          option: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix options alignment
                          }),
                        }}
                      />
                    )}

                    {roleType !== "employee" && (
                      <Select
                        isSearchable
                        isClearable
                        options={businessNameFilterOptions.map((name) => ({
                          value: name,
                          label: name,
                        }))}
                        value={
                          businessNameFilter
                            ? { value: businessNameFilter, label: businessNameFilter }
                            : null
                        }
                        onChange={(selected) => setBusinessNameFilter(selected?.value || "")}
                        placeholder="Filter Name"
                        classNamePrefix="city-react-select-filter"
                        className="ms-2"
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: "155px",
                            display: "inline-block",
                            fontSize: "0.875rem",
                            textAlign: "left",
                          }),
                          control: (base) => ({
                            ...base,
                            minHeight: "31px",
                            height: "31px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 4px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "31px",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix placeholder alignment
                          }),
                          singleValue: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix selected value alignment
                          }),
                          menu: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix dropdown alignment
                            zIndex: 9999,
                          }),
                          option: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix options alignment
                          }),
                        }}
                      />
                    )}

                    {roleType !== "employee" && (
                      <Select
                        isSearchable
                        isClearable
                        options={cities.map((city) => ({ value: city, label: city }))}
                        value={cityFilter ? { value: cityFilter, label: cityFilter } : null}
                        onChange={(selected) => setCityFilter(selected?.value || "")}
                        placeholder="Filter City"
                        classNamePrefix="city-react-select-filter"
                        className="ms-2"
                        styles={{
                          container: (base) => ({
                            ...base,
                            width: "155px",
                            display: "inline-block",
                            fontSize: "0.875rem",
                            textAlign: "left",
                          }),
                          control: (base) => ({
                            ...base,
                            minHeight: "31px",
                            height: "31px",
                          }),
                          valueContainer: (base) => ({
                            ...base,
                            padding: "0 4px",
                          }),
                          indicatorsContainer: (base) => ({
                            ...base,
                            height: "31px",
                          }),
                          placeholder: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix placeholder alignment
                          }),
                          singleValue: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix selected value alignment
                          }),
                          menu: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix dropdown alignment
                            zIndex: 9999,
                          }),
                          option: (base) => ({
                            ...base,
                            textAlign: "left", // <-- fix options alignment
                          }),
                        }}
                      />
                    )}

                    {roleType === "seller" && (
                      <Form.Select
                        className="ms-2"
                        size="sm"
                        value={roleTypeFilter}
                        onChange={(e) => setRoleTypeFilter(e.target.value)}
                        style={{ width: "155px", display: "inline-block" }}
                      >
                        <option value="all">All Role Types</option>
                        <option value={stringConstants.ROLL_TYPE_DISTRIBUTOR}>
                          {stringConstants.ROLL_TYPE_DISTRIBUTOR}
                        </option>
                        <option value={stringConstants.ROLL_TYPE_MANUFACTURER}>
                          {stringConstants.ROLL_TYPE_MANUFACTURER}
                        </option>
                      </Form.Select>
                    )}

                    {roleType === "seller" && (
                      <Form.Select
                        className="ms-2"
                        size="sm"
                        value={subscriptionFilter}
                        onChange={(e) => setSubscriptionFilter(e.target.value)}
                        style={{ width: "150px", display: "inline-block" }}
                      >
                        <option value="all">All Subscriptions</option>
                        <option value="trial">Trial</option>
                        <option value="starter">Starter</option>
                        <option value="booster">Booster</option>
                        <option value="leads">Leads</option>
                      </Form.Select>
                    )}

                    {/* Dropdown in the right column */}
                    <Form.Select
                      id="filter-users-status"
                      className="ms-2"
                      size="sm"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e.target.value)}
                      style={{ width: "150px", display: "inline-block" }}
                    >
                      <option value="all">All Status</option>
                      <option value="1">Active</option>
                      <option value="0">Inactive</option>
                    </Form.Select>

                    {roleType === "employee" && (
                      <Button
                        variant="primary"
                        size="sm"
                        className="ms-2 btn-emp-add btn-save"
                        onClick={() => setCreateEmployee(true)}
                      >
                        <i className="bi bi-plus-lg"></i> Add
                      </Button>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col xs={12} className="px-0">
                <CustomTable
                  columns={
                    roleType === "seller"
                      ? tableStructures.user_list_seller
                      : roleType === "buyer"
                        ? tableStructures.user_list_buyer
                        : roleType === "logistic_partner"
                          ? tableStructures.user_list_lp_bharee
                          : tableStructures.user_list
                  }
                  data={filteredData}
                  enableRowActions={true}
                  positionActionsColumn={"last"}
                  enableTopToolbar={false}
                  emptyTableMsg={"No data found."}
                  enablePagination={true}
                  enableBottomToolbar={true}
                  enableFilters={true}
                  renderRowActions={({ row }) => (
                    <div className="table-action-box">
                      {roleType !== "employee" ? (
                        <Button
                          className="btn-user-list"
                          variant="primary"
                          onClick={() => {
                            dispatch({
                              type: stringConstants.SET_CURRENT_VIEW,
                              payload: stringConstants.USER_DETAILS,
                              currentViewId: row.original.id,
                              currentViewObj: row.original,
                            });
                          }}
                        >
                          <i className="bi bi-eye"></i>
                        </Button>
                      ) : (
                        <Button
                          className="btn-user-list"
                          variant="primary"
                          onClick={() => {
                            setUploadFormObj({
                              ...row.original,
                              mobile: row.original.mobile_number,
                              full_name: row.original.contact_person_name,
                            });
                            setCreateEmployee(true);
                          }}
                        >
                          <i className="bi bi-pencil"></i>
                        </Button>
                      )}
                      &nbsp;
                      {row.original.status === 1 ? (
                        <Button
                          variant="danger"
                          onClick={() => updateUserStatus(row.original.id, dispatch, roleType)}
                          disabled={requestCall?.loading}
                        >
                          <i class="bi bi-slash-circle"></i>
                        </Button>
                      ) : (
                        <Button
                          variant="success"
                          onClick={() => updateUserStatus(row.original.id, dispatch, roleType)}
                          disabled={requestCall?.loading}
                        >
                          <i class="bi bi-check-circle"></i>
                        </Button>
                      )}
                    </div>
                  )}
                  renderTopToolbarCustomActions={() => (
                    <div className="table-heading-wrap">
                      <h4>
                        {(() => {
                          if (roleType === "seller") return "Sellers";
                          else if (roleType === "buyer") return "Buyers";
                          else if (roleType === "employee") return "Employees";
                          else return "Users";
                        })()}
                      </h4>
                    </div>
                  )}
                  initialState={{
                    columnPinning: {
                      right: ["mrt-row-actions"],
                    },
                  }}
                  //   enableColumnOrdering={false} //enable some features
                  //   enableRowSelection={false}
                  //   enableColumnResizing={false}
                  //   onRowSelectionChange={setRowSelection} //hoist internal state to your own state (optional)
                  //   state={{ rowSelection }} //manage your own state, pass it back to the table (optional)
                  //   tableInstanceRef={tableInstanceRef} //get a reference to the underlying table instance (optional)
                />
              </Col>
            </Row>
          );
        } else if (userList?.data?.length < 1 && !userList.loading) {
          return (
            <div>
              <Row className="m-0">
                <Col xs={12} className="px-0" style={{ backgroundColor: "#ffffff" }}>
                  <Row className="m-0 p-0 align-items-center">
                    <Col md={4} xs={12} className="mt-3">
                      <div className="table-heading-wrap">
                        <h4>
                          {(() => {
                            if (roleType === "seller") return "Sellers";
                            else if (roleType === "buyer") return "Buyers";
                            else if (roleType === "employee") return "Employees";
                            else if (roleType === "logistic_partner") return "Logistic Partners";
                            else return "Users";
                          })()}
                        </h4>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <p className="p-2 m-0" style={{ backgroundColor: "#fff" }}>
                <span>
                  {"No user(s) to display... "}
                  <br />
                </span>
                {roleType === "employee" && (
                  <Button
                    variant="primary"
                    className="my-2"
                    size="sm"
                    onClick={() => setCreateEmployee(true)}
                  >
                    <i className="bi bi-plus-lg"></i> Add
                  </Button>
                )}
              </p>
            </div>
          );
        } else if (userList.loading) {
          return <Spinner />;
        }
      })()}
    </Container>
  );
};

export default UsersList;
